module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions-thumbnail/left-table-b9e859bd4b093a3ec46337d2cf7ba978.png";